'use client';

import React from 'react'
import { useAuth } from '../hooks/useAuth'
import { AuthComponentProps } from '../types'
import { Button, Group } from '@mantine/core'
import { IconLogout } from '@tabler/icons-react'

export const Logout: React.FC<AuthComponentProps> = ({ 
  onSuccess, 
  onError 
}) => {
  const { signOut } = useAuth()

  const handleLogout = async () => {
    try {
      await signOut()
      onSuccess?.()
    } catch (error) {
      onError?.(error as Error)
    }
  }

  return (
    <Group justify="center">
      <Button 
        onClick={handleLogout}
        variant="light"
        color="red"
        radius="md"
        leftSection={<IconLogout size={16} />}
      >
        Sign Out
      </Button>
    </Group>
  )
} 